import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import './Signup.css';

function VerifyEmail() {
  const { token } = useParams();
  const [message, setMessage] = useState('Verifying your email...');
  const [error, setError] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(`/api/auth/verify-email/${token}`);
        setMessage(res.data.message);
      } catch (err) {
        setMessage('');
        setError(err.response?.data?.error || 'Unable to verify your email.');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Email Verification</h1>
        {message && <p className="auth-success">{message}</p>}
        {error && <p className="auth-error">{error}</p>}
        <p className="auth-link"><Link to="/login">Continue to login</Link></p>
      </div>
    </div>
  );
}

export default VerifyEmail;